<template>
    <div class="row">
        <div class="col-xl-9 m-2">
            <div class="header">
                <h5>
                    RSVP list
                </h5>
            </div>
        </div>

        <div class="col-xl-9 mb-3">
            <awesome-table
                :labels="tableLabels"
                :items="items"
                :pagination="pagination"
                :filters="filters"
                :options="options"
                :is-loading="isLoading"
                :get-row-class="getRowClass"
                @add-button-click="onAddButtonClick"
                @pagination-change="onPaginationChange"
                @filter-change="onFilterChange"
            >
                <template #[`items.status`]="{item}">
                    {{ item.Event2User.status }}
                </template>
            </awesome-table>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    extends: TableView,

    props: {
        eventId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            includeHeader: false,
            includeDeleteAction: false
        };
    },

    computed: {
        options() {
            return {
                clickableRows: false,
                addButton: false
            };
        },
        labels() {
            return [
                { value: 'firstName', width: '200px' },
                { value: 'lastName', width: '200px' },
                {
                    text: 'Status',
                    value: 'Event2User.status',
                    width: '200px',
                    type: 'enum',
                    enumOptions: ['pending', 'redeemed', 'cancelled', 'scanned']
                }
            ];
        },

        additionalFetchData() {
            return {
                id: this.eventId
            };
        }
    },

    methods: {
        ...mapActions({
            getItems: 'events/getUsers'
        })
    }
};
</script>
